import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SideBar from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import '../../HTMLIntro.css'; // Reusing the same CSS file

const CSSOutline = () => {
  const [expandedSections, setExpandedSections] = useState({});

  const toggleSection = (sectionId) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  const courseSections = [
    { id: 'what-is-css', title: 'What is CSS?', path: '/css-what-is-css' },
    { id: 'importance', title: 'Importance of CSS', path: '/css-importance-of-css' },
    { id: 'latest-features', title: 'Latest CSS3 Features', path: '/css-latest-css3-features' },
    { id: 'syntax', title: 'Syntax and Selectors', path: '/css-syntax-and-selectors' },
    { id: 'how-to-use', title: 'How to use CSS', path: '/css-how-to-use-css' },
    { id: 'display', title: 'The display Properties', path: '/css-the-display-properties' },
    { id: 'width', title: 'Width and Max-width', path: '/css-width-and-maxwidth' },
    { id: 'text-color', title: 'Text Color', path: '/css-text-color' },
    { id: 'letter-spacing', title: 'Letter Spacing', path: '/css-letter-spacing' },
    { id: 'padding', title: 'CSS Padding', path: '/css-css-padding' },
    { id: 'padding-width', title: 'Padding and Element Width', path: '/css-padding-and-element-width' },
    { id: 'border', title: 'CSS Border/Border Style', path: '/css-css-border-and-border-style' }
  ];

  return (
    <HTMLCourseNavProvider>
      <div className="modern-course-container">
        <SideBar />
        
        <div className="course-content">
          <div className="course-header">
            <h1 className="course-title">CSS Course</h1>
            <p className="course-subtitle">Master styling and design for modern websites</p>
            <div className="progress-container">
              <div className="progress-bar">
                <div className="progress-fill" style={{ width: '0%' }}></div>
              </div>
              <span className="progress-text">0% Complete</span>
            </div>
          </div>

          <div className="course-outline-card">
            <div className="card-header">
              <h2 className="card-title">
                <i className="fas fa-palette me-2"></i>
                Course Outline
              </h2>
              <span className="lesson-count">{courseSections.length} lessons</span>
            </div>

            <div className="lessons-container">
              {courseSections.map((section, index) => (
                <div key={section.id} className="lesson-section">
                  <div 
                    className={`lesson-item ${expandedSections[section.id] ? 'expanded' : ''}`}
                    onClick={() => section.sublessons && toggleSection(section.id)}
                  >
                    <div className="lesson-number">
                      {String(index + 1).padStart(2, '0')}
                    </div>
                    
                    <div className="lesson-content">
                      <Link 
                        to={section.path} 
                        className="lesson-title"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {section.title}
                      </Link>
                      
                      {section.sublessons && (
                        <button className="expand-btn">
                          <i className={`fas fa-chevron-${expandedSections[section.id] ? 'up' : 'down'}`}></i>
                        </button>
                      )}
                    </div>

                    <div className="lesson-status">
                      <span className="status-badge">Start</span>
                    </div>
                  </div>

                  {section.sublessons && expandedSections[section.id] && (
                    <div className="sublessons-container">
                      {section.sublessons.map((sublesson, subIndex) => (
                        <Link 
                          key={subIndex} 
                          to={sublesson.path} 
                          className="sublesson-item"
                        >
                          <div className="sublesson-number">
                            {index + 1}.{subIndex + 1}
                          </div>
                          <span className="sublesson-title">{sublesson.title}</span>
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="card-footer">
              <button className="start-course-btn">
                <i className="fas fa-play me-2"></i>
                Start Learning CSS
              </button>
            </div>
          </div>
        </div>
      </div>
    </HTMLCourseNavProvider>
  );
};

export default CSSOutline;